import { computed, Signal } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { EntityProps, EntityState } from '@ngrx/signals/entities';

import { SelectedEntityState } from '../../shared/store/selected-entity.feature';
import { Parcours } from '../models/parcours.model';

export function avecSélecteursParcours<_>() {
  return signalStoreFeature(
    {
      state: type<EntityState<Parcours> & SelectedEntityState>(),
      props: type<EntityProps<Parcours> & { selectedEntity: Signal<Parcours | null> }>(),
    },
    withComputed((store) => ({
      jalons: computed(() => store.selectedEntity()?.jalons.sort((j1, j2) => j1.nom!.localeCompare(j2.nom!)) || []),
      pointsDeDepart: computed(() => store.selectedEntity()?.noeuds.filter((x) => x.estPointDepart)),
      étapes: computed(() => store.selectedEntity()?.noeuds.filter((x) => !x.estPointDepart)),
      groupesÉtapesÀLaCarte: computed(() => store.selectedEntity()?.groupesEtapesALaCarte ?? []),
      noeuds: computed(() => store.selectedEntity()?.noeuds),
      finsParcours: computed(() => store.selectedEntity()?.finsParcours),
      connecteurs: computed(() => store.selectedEntity()?.connecteurs),

      // return jalons names, étapes names, and modules names
      nodeSummary: computed(() => {
        const étapes = store.selectedEntity()?.noeuds.filter((x) => !x.estPointDepart);

        return {
          jalons: store.selectedEntity()?.jalons.map((j) => j.nom),
          étapes: étapes?.map((e) => e.nom),
          modules: étapes?.flatMap((e) => e.modules).map((e) => e.nom),
        };
      }),
    })),
  );
}
